import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Image } from '@mantine/core';
import './NavigationLogo.scss';
import VeryBusyLogo from '../../VeryBusyLogo/VeryBusyLogo';

type NavigationLogoProps = {
	isClickeable?: boolean;
	linkURL?: string;
	customLogo?: string;
};
const NavigationLogo = ( { isClickeable = true, linkURL = '/', customLogo }: NavigationLogoProps ) => (
	<Link className={classNames( 'NavigationLogo', { isClickeable } )} to={linkURL || '/'}>
		{( customLogo
			? <Image src={customLogo} alt="Home" width={82} height={20} fit="contain" />
			: <VeryBusyLogo />
		)}
	</Link>
);

export default NavigationLogo;
